import { createQueryKeys } from "@lukemorales/query-key-factory";
import ResponderCompany from "../ResponderCompany";

export const responderCompanies = createQueryKeys("responderCompanies", {
  all: null,
  overview: (pageNumber: number, pageSize: number) => ({
    queryKey: [{ pageNumber, pageSize }],
    queryFn: () => ResponderCompany.getOverViewCompanies(pageNumber, pageSize),
  }),
  pendingAssociations: (pageNumber: number = 1, pageSize: number = 10) => ({
    queryKey: [{ pageNumber, pageSize }],
    queryFn: () => ResponderCompany.getPendingAssociations(pageNumber, pageSize),
  }),
  allAssociations: (pageNumber: number = 1, pageSize: number = 10) => ({
    queryKey: [{ pageNumber, pageSize }],
    queryFn: () => ResponderCompany.getAllAssociations(pageNumber, pageSize),
  }),
  associationStats: () => ({
    queryKey: ["stats"],
    queryFn: () => ResponderCompany.getAssociationStats(),
  }),
});
